// Mensagem de erro do backend pronta para a tela.
//
// O `message` de um erro da API não é sempre string: o `ValidationPipe` do Nest
// devolve um array, e o 404 da abertura de pagamento (`POST /payments`) devolve
// um objeto `{ pt, en }`. Jogar qualquer um deles direto no `toast.error`
// produz um toast vazio ou "[object Object]" — foi assim que o comprador do
// forumiep (WAID-4992) clicou em "Finalizar compra" e não viu NADA.
//
// Regra: só texto que faz sentido para o comprador sai daqui; o resto vira o
// `fallback`, que é sempre uma frase amigável.
export function getApiErrorMessage(error: unknown, fallback: string): string {
	const e = error as any;
	const message = e?.response?.data?.message ?? e?.message;

	if (typeof message === 'string' && message.trim() !== '') {
		return message;
	}

	if (Array.isArray(message)) {
		const lines = message.filter(
			(item): item is string =>
				typeof item === 'string' && item.trim() !== ''
		);
		if (lines.length > 0) return lines.join(' ');
	}

	if (message && typeof message === 'object') {
		const pt = (message as { pt?: unknown }).pt;
		if (typeof pt === 'string' && pt.trim() !== '') return pt;
	}

	return fallback;
}
